import { FAVORITE_CLICK_EVENT } from '../FavoriteIcon';
import { VenueCardComponent } from './VenueCard';
import Request from '../../utils/Request';
import dataLayer from '../../utils/data-layer';

const IS_PROCESSING_CLASS = 'is-processing';

export const FAVORITE_TOGGLE_EVENT = 'favoriteVenueToggle';

export class FavoriteVenueCardComponent extends VenueCardComponent {
  static key = 'lta-favorite-venue-card';

  static get observedAttributes() {
    return [...super.observedAttributes, 'venue-city', 'venue-postalcode', 'is-favorite', 'venue-detail-page-url'];
  }

  constructor() {
    super();
  }

  onLoad() {
    this.setState({
      isFavorite: this.props.isFavorite
    });

    this.addEventListener(FAVORITE_CLICK_EVENT, async (event) => {
      const { isFavorite } = event.detail;
      const action =  isFavorite ? "added" : "removed";
      this.pushDataLayer('favourite_click', action);
      await this.toggleHandler(event);
      this.dispatchEvent(new CustomEvent(FAVORITE_TOGGLE_EVENT, {
        bubbles: true,
        composed: true,
        detail: {
          isFavorite: isFavorite,
          venueId: this.props.venueId
        }
      }));
    });
  }

  async toggleHandler(event) {
    const { isFavorite } = event.detail;
    const target = event.target;

    // Prevent multiple clicks
    if (target.classList.contains(IS_PROCESSING_CLASS)) return;
    target.classList.add(IS_PROCESSING_CLASS);

    try {
      if (isFavorite) {
        // Add to favorites
        await this.addVenueToFavorites(event.target);
      } else {
        // Remove from favorites
        await this.removeVenueFromFavorites(event.target); // favorite icon clicked
      }
    } catch (error) {
      console.error('API error:', error);
    } finally {
      // only reset if immediate add (not when showing modal)
      target.classList.remove(IS_PROCESSING_CLASS);
    }
  }

  async addVenueToFavorites() {
    try {
      const { addToFavoritesUrl, venueId, venueName, venueImageUrl } = this.props;

      const response = await Request.put(`${addToFavoritesUrl}`, { venueId, venueName, imageUrl: venueImageUrl }).catch((e) => {
        console.error(e);
      });

      if (response?.errors?.errorCode === '00') {
        this.pushDataLayer('favourite_added', 'added');
        this.setState({
          isFavorite: true
        });
      }
      return response;
    } catch (error) {
      console.error('API error:', error);
      throw error;
    }
  }

  async removeVenueFromFavorites() {
    try {
      const { removeFromFavoritesUrl, venueId } = this.props;

      const response = await Request.delete(removeFromFavoritesUrl, { venueId }).catch((e) => {
        console.error(e);
      });

      if (response?.errors?.errorCode === '00') {
        this.pushDataLayer('favourite_removed', 'removed');
        this.setState({
          isFavorite: false
        });
      }
      return response;
    } catch (error) {
      console.error('API error:', error);
      throw error;
    }
  }

  pushDataLayer(event, action) {
    const { venueId, venueName } = this.props;
    if(!dataLayer) {
        return;
    }
    const defaultFavouriteData = {
        event: event,
        venue_id: venueId,
        venue_name: venueName
    };
    switch(event) {
        case 'favourite_click':
            dataLayer.push({
              ...defaultFavouriteData,
              screen: 'venue_details',
              favourite_status: action,
            });
            break;
                            
        case 'favourite_added':
        case 'favourite_removed':
            dataLayer.push({
                ...defaultFavouriteData,
                favourite_status: action,
            });
            break;
    }
}

  render() {
    const { venueId, venueName, venueImageUrl, venueCity, venuePostalcode, venueCtaButtonLabel, venueDetailPageUrl } = this.props;
    const { isFavorite } = this.state;

    return `
      <div class="lta-card lta-game-venue-card__court-booking-page u-mb-3 u-border-0">
        <input type="hidden" data-current-venue-id=${venueId} />
				<a href=${venueDetailPageUrl}>
					<img
						class="venue-card-image lta-card-img-top u-rounded"
						alt="${venueName}"
						src=${venueImageUrl}
					/>
				</a>
				<div class="u-py-2">
					<div class="u-flex u-justify-space-between">
						<a class="text-decoration-none" href=${venueDetailPageUrl}>
							<p class="u-h1 venue-card-title lta-card-text">${venueName}</p>
						</a>
						<lta-favorite-icon 
							class="u-cursor-pointer js-fav-icon"
							is-favorite=${isFavorite}
							id="${venueId}"
						></lta-favorite-icon>
					</div>
					<p class="u-body1 venue-card-address lta-card-text u-mt-1">
						${venueCity} ${venuePostalcode}
					</p>
					<lta-button label="${venueCtaButtonLabel}" href="${venueDetailPageUrl}" tag="a" size="md" type="link" classes="text-decoration-underline u-text-lta-blue u-caption2 u-mt-1"></lta-button>
				</div>
			</div>
    `;
  }
}

export default FavoriteVenueCardComponent;